import type { Locale } from 'types/users';
import mirrorCreator from 'utilities/mirrorCreator';

// Form options

export const FIELD_DEBOUNCE_DELAY_MS = 500;
export const FIELD_LONG_DEBOUNCE_DELAY_MS = 1500;

// Table options

export const DEFAULT_TABLE_ROWS_PER_PAGE = 100;
export const DEFAULT_MINI_TABLE_ROWS_PER_PAGE = 10;

export const TIMELINE_ALGORITHMS = [
  { value: 'fixed', label: 'Fixed' },
  { value: 'fomo', label: 'Fomo' },
  { value: 'stragglers', label: 'Stragglers' },
  { value: 'otot', label: 'Otot' },
];

export const AVAILABLE_LOCALES: { [key in Locale]: string } = {
  en: 'English',
  zh: '中文',
  ko: '한국어',
};

export const SAVING_STATUS = mirrorCreator([
  'None',
  'Saving',
  'Saved',
  'Failed',
]);

export const MAX_SAVING_SIZE = 2_000_000; // 2MB
export const ANSWER_TOO_LARGE_ERR = 'exceed_size_limit';
// About 15 minutes of recording at the ~128 kbps browsers typically default to. Slightly stricter than the
// server's Course::Assessment::Answer::VoiceResponse::MAX_FILE_SIZE (15 MiB).
export const MAX_VOICE_RESPONSE_FILE_SIZE = 15_000_000; // 15MB

export const SYNC_STATUS = mirrorCreator(['Synced', 'Syncing', 'Failed']);

export const MATERIAL_WORKFLOW_STATE = mirrorCreator([
  'not_chunked',
  'chunking',
  'chunked',
]);

export const POST_WORKFLOW_STATE = mirrorCreator([
  'draft',
  'published',
  'delayed',
  'answering',
]);

export const ASSESSMENT_SIMILARITY_WORKFLOW_STATE = mirrorCreator([
  'not_started',
  'starting',
  'running',
  'completed',
  'failed',
]);

export default {
  TIMELINE_ALGORITHMS,
  AVAILABLE_LOCALES,
};

export const SUPPORT_EMAIL =
  process.env.SUPPORT_EMAIL ?? 'coursemology@gmail.com';

export const DEFAULT_LOCALE = process.env.DEFAULT_LOCALE ?? 'en';

export const DEFAULT_TIME_ZONE =
  process.env.DEFAULT_TIME_ZONE ?? 'Asia/Singapore';

export const NUM_CELL_CLASS_NAME = 'text-right';
